import { PropsWithChildren } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';

import useTheme from '@repo/hooks/useTheme';
import { GlobalStyle, affiliateThemeByService } from '@repo/styles';
import { UIThemeProvider } from '@repo/ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import ModalStackProvider from '../modal/ModalStackProvider';

export type OutletChildType = {
  device: { isMobile: boolean; isLaptop: boolean; isDesktop: boolean; isXLarge: boolean };
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      useErrorBoundary: true,
      retry: 0,
      refetchOnWindowFocus: false,
      networkMode: 'always',
    },
    mutations: {
      useErrorBoundary: true,
      networkMode: 'always',
    },
  },
});

const GlobalProvider = ({ children }: PropsWithChildren) => {
  const { theme } = useTheme(affiliateThemeByService());

  // const domain = import.meta.env.VITE_APP_BASE_URL;

  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <UIThemeProvider theme={theme}>
          <GlobalStyle />
          {children}
          <Toaster
            containerStyle={{
              top: '50%',
            }}
          />
          <ModalStackProvider />
        </UIThemeProvider>
      </HelmetProvider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};

export default GlobalProvider;
